"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.fill");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _utils = require("@/utils");
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _Export2Excel = require("@/vendor/Export2Excel");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ConfirmPrintingDialogPh',
  components: {
    Pagination: _index.default,
    dragDialog: _DragDialog.default
  },
  props: {
    formDialog: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabledType: {
      type: Boolean,
      default: false
    },
    params: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      fileList: [],
      isRequestCompleted: false,
      poolTypeList: [],
      listQuery: {
        currentPage: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [],
      details: [],
      //
      loading: null,
      isRequesting: false,
      billNo: '',
      blNo: '',
      hasDemurrage: false,
      // 新增确认弹窗相关数据
      confirmDialogVisible: false,
      demurrageAmount: '',
      startMoveDate: '',
      exchangeRate: '',
      endMoveDate: '',
      phpAmount: '',
      form: {
        blNo: '',
        appointmentStatus: '',
        deliveryOrderType: '',
        paymentStatus: '',
        paymentMethod: '',
        paymentTitle: '',
        taxpayerIdentificationNumber: '',
        address: '',
        invoiceTitleTaxNumber: '',
        invoiceTitleAccount: '',
        poolType: '',
        masterDataCode: '',
        imoNo: '',
        builderName: '',
        authorizationStatus: '',
        authorizedCustomer: ''
      },
      resData: [],
      hotSettings: {
        dragCheck: true,
        height: '300px',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    this.opened();
    console.log('confirmPrintingDialogPh created');
  },
  mounted: function mounted() {},
  methods: {
    opened: function opened() {
      var _this = this;
      if (this.isRequesting) {
        return;
      }
      this.isRequesting = true;

      // 添加延迟确保前一个弹窗的loading完全关闭
      this.$nextTick(function () {
        setTimeout(function () {
          _this.loading = (0, _utils.load)({
            lock: true,
            text: _this.$t('common.loading'),
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            customClass: 'global-loading-top-layer'
          });
          _this.isRequestCompleted = false;
          if (!_this.params || _this.params.length === 0) {
            _this.isRequestCompleted = true;
            if (_this.loading) {
              _this.loading.close();
            }
            _this.isRequesting = false;
            return;
          }

          // 执行API请求
          _this.executeRequest();
        }, 100); // 延迟100ms确保前一个loading完全关闭
      });
    },
    // 提取API请求逻辑到单独方法
    executeRequest: function executeRequest() {
      var _this2 = this;
      (0, _blExchangeAppointment.doForespeakPH)(this.params).then(function (res) {
        if (res && res.success) {
          _this2.resData = res.data;
          _this2.billNo = res.data[0].billNo;
          _this2.tableData = res.data[0].ecmDemurrageBillDetails;
          _this2.details = res.data[0].details; // 用作内容的提示和后续提交保存对账单

          // 处理日期格式，只保留年月日
          _this2.tableData = _this2.tableData.map(function (item) {
            // 格式化startMoveDate
            if (item.startMoveDate) {
              item.startDate = _this2.formatDateToYYYYMMDD(item.startMoveDate);
            }

            // 格式化endMoveDate
            if (item.endMoveDate) {
              item.endDate = _this2.formatDateToYYYYMMDD(item.endMoveDate);
            }
            if (item.freeUntil) {
              item.freeUntilDate = _this2.formatDateToYYYYMMDD(item.freeUntil);
            }

            // 安全计算realFee
            var realTargetFee = _this2.moneyToNumber(item.realTargetFee || 0);
            var amountTax = _this2.moneyToNumber(item.amountTax || 0);

            // 相加并保留两位小数
            item.realFee = _this2.formatNumber(realTargetFee + amountTax);
            if (item.exchangeRate) {
              item.calAmount4PHP = _this2.formatNumber(item.realFee * item.exchangeRate);
            }
            _this2.blNo = item.blNo;
            return item;
          });

          // 新增：过滤details数组，创建newDetails
          var newDetails = [];
          if (_this2.details && _this2.details.length > 0) {
            // 遍历details中的每个元素
            _this2.details.forEach(function (d1) {
              // 在tableData中查找匹配的元素,即结束日期需要对应,匹配得到的是最新的对账单数据
              var matchedItem = _this2.tableData.find(function (d2) {
                return d2.containerNo === d1.containerNo && _this2.isSameDate(d2.endMoveDate, d1.endMoveDate);
              });
              // 汇率是从对应箱号+提单号的Account中取出的，目前看没问题
              // 如果找到匹配项，则将该detail元素添加到newDetails中
              if (matchedItem) {
                // 格式化日期
                // d1.startMoveDate = this.formatDateToYYYYMMDD(d1.startMoveDate);
                // d1.endMoveDate = this.formatDateToYYYYMMDD(d1.endMoveDate);
                // 记录汇率，稍后统一计算
                d1.exchangeRate = matchedItem.exchangeRate;
                newDetails.push(d1);
                _this2.startMoveDate = _this2.formatDateToYYYYMMDD(d1.startMoveDate);
                _this2.endMoveDate = _this2.formatDateToYYYYMMDD(d1.endMoveDate);
                _this2.exchangeRate = d1.exchangeRate;
              }
            });
          }

          // 更新this.details为过滤后的数组
          _this2.details = newDetails;

          // 计算费用总和
          var totalUSD = 0;
          var totalPHP = 0;
          if (_this2.details && _this2.details.length > 0) {
            _this2.details.forEach(function (detail) {
              // 安全计算realFee
              var realTargetFee = _this2.moneyToNumber(detail.realTargetFee || 0);
              var amountTax = _this2.moneyToNumber(detail.amountTax || 0);

              // 相加并保留两位小数
              var curFee = _this2.formatNumber(realTargetFee + amountTax);
              // 计算PHP金额
              detail.phpAmount = _this2.formatNumber(curFee * detail.exchangeRate);
              // 累加总费用
              totalUSD += _this2.moneyToNumber(curFee || 0);
              totalPHP += _this2.moneyToNumber(detail.phpAmount || 0);
            });
          }
          // 存储总费用信息，供后续使用
          _this2.demurrageAmount = "USD: ".concat(_this2.formatNumber(totalUSD));
          _this2.phpAmount = _this2.formatNumber(totalPHP);

          // 检查是否有滞期费
          _this2.hasDemurrage = _this2.tableData.some(function (item) {
            var realTargetFee = _this2.moneyToNumber(item.realTargetFee || 0);
            var amountTax = _this2.moneyToNumber(item.amountTax || 0);
            return realTargetFee + amountTax > 0;
          });
          if (_this2.$refs.hotTable && _this2.$refs.hotTable.hotInstance) {
            _this2.$refs.hotTable.hotInstance.loadData(_this2.tableData);
            _this2.$refs.hotTable.resizeTo();
          }
        } else {
          _this2.tableData = [];
        }
      }).catch(function (error) {
        console.error('请求失败:', error);
        _this2.$message.error('请求失败');
      }).finally(function () {
        _this2.isRequestCompleted = true;
        _this2.loading && _this2.loading.close();
        _this2.isRequesting = false;
      });
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    handlePreviousStep: function handlePreviousStep() {
      this.$emit('handlePreviousStep');
    },
    handleNext: function handleNext() {
      var _this3 = this;
      this.loading = (0, _utils.load)({
        lock: true,
        text: this.$t('common.loading'),
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'global-loading-top-layer'
      });
      var params = this.resData;

      // 准备并调用savePickUpCtnDate4Submit，参数为blNo和containerNo
      var pickUpParams = this.tableData.map(function (item) {
        return {
          blNo: item.blNo,
          containerNo: item.containerNo
        };
      });

      // 获取滞期费状态
      var hasDemurrage = this.tableData.some(function (item) {
        // 安全计算realTargetFee和amountTax之和
        var realTargetFee = _this3.moneyToNumber(item.realTargetFee || 0);
        var amountTax = _this3.moneyToNumber(item.amountTax || 0);
        var total = realTargetFee + amountTax;
        return total > 0;
      });

      // 如果有滞期费，弹出确认窗口，并且进行保存对账单操作
      if (hasDemurrage) {
        // 显示确认弹窗
        this.confirmDialogVisible = true;
        // 先调用savePickUpCtnDate4Submit，完成后再调用saveDemurrageBills
        (0, _blExchangeAppointment.savePickUpCtnDate4Submit)(pickUpParams).then(function () {
          // 第一个API调用成功后，继续调用第二个API
          return (0, _blExchangeAppointment.saveDemurrageBills)(params);
        }).then(function (res) {}).catch(function (error) {
          console.error('保存数据失败:', error);
          _this3.$message.error(_this3.$t('common.saveFailed') || '保存失败');
        }).finally(function () {
          _this3.loading.close();
        });
      } else {
        // 没有滞期费，直接进入下一步
        this.$emit('handleNextStep', 'F');
      }
      // 更新组件的hasDemurrage状态，确保按钮文本一致
      this.hasDemurrage = hasDemurrage;
    },
    handlePageChange: function handlePageChange() {},
    closed: function closed() {},
    formatDateToYYYYMMDD: function formatDateToYYYYMMDD(date) {
      if (date) {
        var formattedDate = new Date(date);
        var year = formattedDate.getFullYear();
        var month = String(formattedDate.getMonth() + 1).padStart(2, '0');
        var day = String(formattedDate.getDate()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
      }
      return '';
    },
    moneyToNumber: function moneyToNumber(value) {
      if (typeof value === 'string') {
        return Number(value.replace(/[^0-9.]/g, ''));
      } else if (typeof value === 'number') {
        return value;
      } else {
        throw new Error('Invalid format for moneyToNumber');
      }
    },
    formatNumber: function formatNumber(value) {
      return Number(value).toFixed(2);
    },
    // 新增关闭确认弹窗方法
    handleCloseConfirmDialog: function handleCloseConfirmDialog() {
      this.confirmDialogVisible = false;
      this.$emit('update:visible', false);
    },
    // 新增下载Excel方法
    handleDownloadExcel: function handleDownloadExcel() {
      try {
        // 准备表头
        var header = [this.$t('blExchangeAppointment.vesselCode'), this.$t('blExchangeAppointment.voyageNo'), this.$t('blExchangeAppointment.blNo'), this.$t('blExchangeAppointment.containerNo'), this.$t('blExchangeAppointment.containerType'), this.$t('blExchangeAppointment.dem'), this.$t('blExchangeAppointment.dg'), this.$t('blExchangeAppointment.startDate'), this.$t('blExchangeAppointment.endDate'), this.$t('blExchangeAppointment.FreeUntil'), this.$t('blExchangeAppointment.OverDay'), this.$t('blExchangeAppointment.ftNo'), this.$t('blExchangeAppointment.confirmCurrency'), this.$t('blExchangeAppointment.confirmAmount'), this.$t('blExchangeAppointment.tax'), this.$t('blExchangeAppointment.amount4PHP')];

        // 准备数据
        var data = this.tableData.map(function (item) {
          return [item.vesselCode || '', item.voyageNo || '', item.blNo || '', item.containerNo || '', item.containerType || '', item.demurrageType || '', item.dgFlag || '', item.startDate || '', item.endDate || '', item.freeUntilDate || '', item.overDays || '', item.freeTimeNo || '', item.realTargetCurrency || '', item.realFee || '', item.amountTax || '', item.calAmount4PHP || ''];
        });

        // 计算calAmount4PHP的总和
        var totalAmount4PHP = this.tableData.reduce(function (sum, item) {
          return sum + (Number(item.calAmount4PHP) || 0);
        }, 0);

        // 添加合计行
        var totalRow = Array(15).fill('').concat([totalAmount4PHP.toFixed(2)]);
        totalRow[0] = '合计';

        // 将合计行添加到数据中
        data.push(totalRow);

        // 导出Excel
        (0, _Export2Excel.export_json_to_excel)({
          header: header,
          data: data,
          filename: "\u6EDE\u671F\u8D39\u660E\u7EC6-".concat(this.billNo, "-").concat(new Date().toISOString().slice(0, 10)),
          autoWidth: true,
          bookType: 'xlsx'
        });

        // 下载成功提示
        this.$message.success('导出成功');

        // 下载后关闭所有弹窗
        this.confirmDialogVisible = false;
        this.$emit('update:visible', false);
      } catch (error) {
        console.error('导出Excel失败:', error);
        this.$message.error('导出失败');
      }
    },
    // 添加一个辅助方法用于比较日期是否相同（考虑到可能需要日期格式的一致性）
    isSameDate: function isSameDate(date1, date2) {
      // 如果任一日期为空，则无法比较
      if (!date1 || !date2) return false;

      // 将日期转换为相同格式进行比较
      var formattedDate1 = this.formatDateToYYYYMMDD(date1);
      var formattedDate2 = this.formatDateToYYYYMMDD(date2);
      return formattedDate1 === formattedDate2;
    }
  }
};